/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, ReactElement } from 'react';
import { Tooltip } from '@mui/material';
import { createColumnHelper } from '@tanstack/react-table';
import moment from 'moment';
import { Table } from 'src/components';
import { RowHover } from 'src/components/Table';
import { MdOutlineFileDownload, MdOutlineVisibility } from 'react-icons/md';
import { getFileIcon, getFileName } from '../../utils';
import {
  ActionDivProps,
  DocsListViewProps,
  DocumentResponse,
} from '../../types';

const ActionDiv = function addAction(props: ActionDivProps) {
  const { info, onDocumentView, onDocumentDownload } = props;
  return (
    <div className="flex flex-row justify-center items-center gap-2">
      <Tooltip title="Download">
        <button
          type="button"
          className="border-none cursor-pointer bg-transparent"
          onClick={() => onDocumentDownload(info)}
        >
          <MdOutlineFileDownload className="w-5 h-5 text-secondary" />
        </button>
      </Tooltip>
      <Tooltip title="Preview">
        <button
          type="button"
          onClick={() => onDocumentView(info)}
          className="border-none cursor-pointer bg-transparent"
        >
          <MdOutlineVisibility className="w-5 h-5 text-secondary" />
        </button>
      </Tooltip>
    </div>
  );
};

function DocsListView(props: DocsListViewProps) {
  const {
    documentList,
    onDocumentDownload,
    onDocumentView,
    tableTitle,
  } = props;
  const [rowHover, setRowHover] = useState<RowHover>({});

  const onRowHover = (data: RowHover): void => {
    setRowHover(data);
  };

  const getIcon = (fileName: string): ReactElement => {
    const Component = getFileIcon(fileName);
    return <Component className="w-7 h-7 text-secondary mr-2" />;
  };

  const columnHelper = createColumnHelper<DocumentResponse>();
  const columns = [
    columnHelper.accessor('documentId', {
      header: () => <div className="pl-5">S.No</div>,
      cell: (info) => <div className="pl-5">{info.row.index + 1}</div>,
    }),
    columnHelper.accessor('documentName', {
      header: () => 'Name',
      cell: (info) => (
        <div className="flex flex-row items-center break-all">
          {getIcon(info.row.original.documentName)}
          <Tooltip title={info.getValue()}>
            <span>{getFileName(info.getValue(), 40).name}</span>
          </Tooltip>
        </div>
      ),
    }),
    columnHelper.accessor('updatedDate', {
      header: () => 'Uploaded At',
      cell: (info) => moment(info.getValue()).format('DD-MM-YYYY'),
    }),
    columnHelper.accessor('presignedUrl', {
      header: () => '',
      cell: (info) => (
        <div className="flex justify-center items-center min-w-[100px] min-h-[40px]">
          {rowHover[info.row.index] && (
            <ActionDiv
              info={info.row.original as unknown as DocumentResponse}
              onDocumentDownload={onDocumentDownload}
              onDocumentView={onDocumentView}
            />
          )}
        </div>
      ),
    }),
  ];

  return (
    <div className="bg-white">
      <Table
        title={tableTitle}
        data={documentList}
        columns={columns}
        pageSize={5}
        onRowHover={onRowHover}
      />
    </div>
  );
}

export default DocsListView;
